// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3lV2M","buttons":"PendingPaymentAlert_buttons__3WGO9"};